import { SlotSelectionFieldTimeLapsedOptionType } from '../../types';
import {
    getFilterOptionsByDependentValue,
    getSlotsBasedOnShouldShowNextWeek,
    getSortedSlotOptions,
    removeSlotBasesOnConditions
} from '../../hooks/useInformedSlotSelectionField/useInformedSlotSelectionFieldUtil';

import { getLabelText } from '../DateTimeUtils';
import { getTimeLapsedValues } from '../TimeLapsedUtils';

export const getSlotsBasedOnSlotConditionsAndDependentFieldValue = (
    slotOptions: SlotSelectionFieldTimeLapsedOptionType[],
    slotConditions: Record<string, string>,
    dependentFieldValue: string,
    isDateBasedSlots: boolean,
    values: Record<string, any>
) => {
    if (slotConditions) {
        slotOptions = removeSlotBasesOnConditions(
            { ...slotConditions },
            slotOptions,
            values
        );
    }

    if (dependentFieldValue && !isDateBasedSlots) {
        slotOptions = getFilterOptionsByDependentValue(
            slotOptions,
            dependentFieldValue
        );
    }

    slotOptions = getSortedSlotOptions([...slotOptions]);

    return slotOptions;
};

export const getDatesToShowSlotsBasedOnOptionType = (
    date: Date,
    optionType: string,
    slotOptions: SlotSelectionFieldTimeLapsedOptionType[],
    isDateBasedSlots?: boolean
) => {
    const slotOptionsObject = {
        date: date,
        label: getLabelText(date),
        options: getTimeLapsedValues({
            timeLapsedOptions: getSlotsBasedOnShouldShowNextWeek(
                slotOptions,
                optionType,
                date,
                isDateBasedSlots
            ),
            selectedDate: date
        })
    };

    return slotOptionsObject;
};

